<div class="vd-layout">
  <app-navbar (toggleSidebarEvent)="onToggleSidebar()"></app-navbar>

  <div class="vd-content-wrap">
    <!-- Sidebar : desktop visible / mobile drawer -->
    <app-sidebar
      class="vd-sidebar-host"
      [class.is-mobile-open]="mobileDrawerOpen()"
    ></app-sidebar>

    <!-- Backdrop mobile drawer -->
    <div
      class="vd-drawer-backdrop"
      *ngIf="mobileDrawerOpen()"
      (click)="closeDrawer()"
      aria-hidden="true"
    ></div>

    <main class="vd-main vd-hero-bg">
      <!-- Référence permanente vers la vérification de profil : visible sur
           toutes les pages protégées tant que la vente n'est pas débloquée
           (alignée sur le gate API via can_sell). CTA → /CompleteSignUp. -->
      <vd-vendor-status-banner></vd-vendor-status-banner>
      <router-outlet></router-outlet>
    </main>
  </div>

  <app-bottom-tab-bar></app-bottom-tab-bar>
  <app-global-search-palette></app-global-search-palette>
  <vd-toast-host></vd-toast-host>

  <!-- Onboarding : FAB flottant universel + drawer global (lazy via *ngIf) -->
  <app-onboarding-fab></app-onboarding-fab>
  <app-onboarding-drawer *ngIf="onboarding.drawerOpen()"></app-onboarding-drawer>

  <!-- Guide video contextuel : monte au composant RACINE (app.component)
       pour couvrir aussi les pages hors layout (ex: /CompleteSignUp). -->
</div>
